import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import "./Tabs.scss";
import Icon from "../Icon";
import { useSelector, useDispatch } from "react-redux";
import {
  setActiveTab,
  setActiveSuiteTab,
  setActiveCommonAreaTab,
  setActiveContactTab,
  setActiveCatalogTab,
} from "../../store/actions/activeTab";

const Tabs = ({ items, activeTab, from, hideEmptyTabs = false }) => {
  const tabsElementRef = useRef(null);

  const dispatch = useDispatch();

  // Why in the hell is this in redux? Why not just use local state? https://trello.com/c/zsa92dIf
  const currentActiveTab = useSelector(
    (state) => state.activeTab?.activeTab || 0
  );
  const currentActiveSuiteTab = useSelector(
    (state) => state.activeTab?.suiteActiveTab || 0
  );
  const currentActiveCommonAreaTab = useSelector(
    (state) => state.activeTab?.commonAreaActiveTab || 0
  );
  const currentActiveContactTab = useSelector(
    (state) => state.activeTab?.contactActiveTab || 0
  );
  const currentActiveCatalogTab = useSelector(
    (state) => state.activeTab?.catalogActiveTab || 0
  );
  const [itemIndex, setItemIndex] = useState(
    activeTab
      ? activeTab
      : from === "suite"
      ? currentActiveSuiteTab
      : from === "Property"
      ? currentActiveTab
      : from === "CommonArea"
      ? currentActiveCommonAreaTab
      : from === "Contact"
      ? currentActiveContactTab
      : from === "Catalog"
      ? currentActiveCatalogTab
      : 0
  );

  const [showLeftChevron, setShowLeftChevron] = useState(false);
  const [showRightChevron, setShowRightChevron] = useState(false);

  useEffect(() => {
    const tabsElement = tabsElementRef.current;
    if (!tabsElement) return;

    const handleScroll = () => {
      if (tabsElement.scrollLeft === 0) {
        setShowLeftChevron(false);
      } else {
        setShowLeftChevron(true);
      }

      if (
        tabsElement.scrollLeft + tabsElement.clientWidth ===
        tabsElement.scrollWidth
      ) {
        setShowRightChevron(false);
      } else {
        setShowRightChevron(true);
      }
    };

    tabsElement.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      tabsElement.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const incrementTabIndex = (value) => {
    if (from === "suite") {
      setItemIndex(value);
      dispatch(setActiveSuiteTab(value));
    } else if (from === "Property") {
      setItemIndex(value);
      dispatch(setActiveTab(value));
    } else if (from === "CommonArea") {
      setItemIndex(value);
      dispatch(setActiveCommonAreaTab(value));
    } else if (from === "Contact") {
      setItemIndex(value);
      dispatch(setActiveContactTab(value));
    } else if (from === "Catalog") {
      setItemIndex(value);
      dispatch(setActiveCatalogTab(value));
    } else {
      setItemIndex(value);
    }
  };

  return (
    <div
      className={classNames("tabs", {
        "tabs--show": items.length > 1,
      })}
    >
      {items.length > 1 && (
        <div className="tabs__wrapper">
          <div className="tabs__items" ref={tabsElementRef}>
            {items.map((i, x) => {
              if (!i.label) return <></>;

              if (hideEmptyTabs && parseInt(i.count) === 0) return <></>;

              return (
                <button
                  key={x}
                  className={classNames("tabs__item", {
                    "tabs__item--active": x === itemIndex,
                  })}
                  onClick={() => incrementTabIndex(x)}
                >
                  {i.label}{" "}
                  {i.count && <span className="tabs__count">{i.count}</span>}
                </button>
              );
            })}
          </div>

          <div className={"tabs__fade left " + (showLeftChevron ? "" : "hidden")}>
            <Icon glyph="chevron-double-left" weight="solid" />
          </div>

          <div className={"tabs__fade " + (showRightChevron ? "" : "hidden")}>
            <Icon glyph="chevron-double-right" weight="solid" />
          </div>
        </div>
      )}
      <div className="tabs__content">
        {items
          .filter((i, x) => x === itemIndex)
          .map((i, x) => (
            <div key={x}>{i.content}</div>
          ))}
      </div>
    </div>
  );
};

export default Tabs;
